export const API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_TEMPLATES_TEMPLATEID_PATH_KEY =
  '/organizations/{organizationId}/quizzes/templates/{templateId}';
export const API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_PATH_KEY =
  '/organizations/{organizationId}/quizzes/completions';
export const API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_NEXT_PATH_KEY =
  '/organizations/{organizationId}/quizzes/completions/{id}/next';
export const API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_ID_RESULT_PATH_KEY =
  '/organizations/{organizationId}/quizzes/completions/{id}/result';
